<template>
  <div class="info-container">
    <div class="info-form">
      <h2>Job/Business Information</h2>
      <form class="employment">
        <h4>What’s your employment status?</h4>
        <input-select
          v-model="form.employmentStatus"
          :items="employmentOptions"
          :command="getCustProductDetails"
        />
        <!-- :error="formErrors.ticketId"
            label="What’s your employment status?"
            type="text"
            autocomplete="nopenklnglnmgdlmlmdlmlmlfml"
            name="ticket123"
            id="ticket123" -->
        <h4>What’s your monthly income?</h4>
        <input-select
          v-model="form.incomeRange"
          :items="incomeOptions"
          :command="getCustProductDetails"
        />
      </form>
    </div>
    <div class="illustration">
      <div class="description">
        Kindly provide your employment status and monthly income range
      </div>
      <img
        :src="require('../../../../assets/img/polygon.svg')"
        class="polygon"
        alt="Comment Bubble"
      />
      <img :src="require('../../../../assets/img/male-tablet.gif')" alt="" />
    </div>
  </div>
</template>

<script>
import InputSelect from "../components/InputSelect.vue";
import { mapGetters } from "vuex";

export default {
  name: "JobInformation",
  props: ["updateStatus", "updateTracker", "getCustomerEmploymentDetails"],
  components: {
    InputSelect
  },
  computed: {
    ...mapGetters(["getUserSession"])
  },
  data() {
    return {
      form: {
        employmentStatus: "",
        incomeRange: ""
      },
      formErrors: {},
      employmentOptions: [
        { id: "Employed", name: "Employed" },
        { id: "Self Employed", name: "Self Employed" }
      ],
      incomeOptions: [
        { id: "1", name: "Below NGN500,000" },
        { id: "2", name: "Between NGN500,000 and NGN750,000" },
        { id: "3", name: "Between NGN750,000 and NGN1,000,000" },
        { id: "4", name: "Above NGN1,000,000" }
      ]
    };
  },
  methods: {
    getCustProductDetails() {
      this.getCustomerEmploymentDetails({
        monthlyIncomeRange: this.form.incomeRange,
        employmentStatus: this.form.employmentStatus
      });
    },
    getProductPackage() {
      this.productPackage = this.$store.state.onboardingPackageType;
      this.typeProduct = this.productPackage.amountOS;
      this.productName = this.productPackage.name;
    }
  },
  mounted() {
    // console.log("rfsf" , this.$store.state.onboardingCustomerState)
    this.updateTracker(true);
    this.updateStatus(2);
    this.getProductPackage();
    this.getCustProductDetails();
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/_reduced_variables.scss";

h1,
h2,
h3,
h4,
p {
  margin: 0;
  padding: 0;
  font-family: "DM Sans", sans-serif;
  font-weight: 400;
}

p {
  color: #727272;
  font-size: 16px;
  line-height: 24px;
}

h2 {
  color: #0892d0;
  margin-bottom: 18px;
  font-weight: 700;
}

.info-container {
  display: flex;
  justify-content: space-between;
  width: 100%;

  .info-form {
    width: 40%;
  }

  h2 {
    margin-bottom: 35px;
  }

  h4 {
    font-weight: 700;
    font-size: 16px;
    color: #fe7a11;
    margin: 13px 0px;
  }
}

.illustration {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  max-width: 350px;

  img:first-child {
    margin-bottom: -3rem;
    z-index: 3;
  }
}

.description {
  max-width: 340px;
  border-radius: 40px;
  padding: 32px 20px;
  background: #e6f6ff;
  text-align: center;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: #0892d0;
}

.polygon {
  width: 5.3rem;
  height: 5.8rem;
  margin-left: 21rem;
  margin-top: -1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/onboarding/leaseToOwn/JobInformation.vue